/**
 * Registrazione del service worker.
 *
 * Si registra **dopo l'accesso**, non al caricamento della pagina.
 *
 * La console sta sullo stesso host da cui vive il widget dell'ente: con la
 * registrazione automatica bastava aprire quella radice — cosa che chi ha
 * chiamato può fare per sbaglio, e che dalla fase 5 farà di proposito — per
 * ritrovarsi sul dispositivo un service worker e una cache che nessuno aveva
 * chiesto. Sono tracce persistenti, sopravvivono alla cancellazione della
 * cronologia, e sono esattamente ciò che la sezione 7ter vuole evitare.
 *
 * Le notifiche riguardano chi è in turno: chi non è entrato non ha niente da
 * installare.
 */

let started = false;

export async function registerServiceWorker(): Promise<void> {
  if (started) return;
  if (typeof globalThis.navigator === 'undefined' || !('serviceWorker' in globalThis.navigator)) {
    return;
  }
  started = true;

  try {
    const { registerSW } = await import('virtual:pwa-register');
    /**
     * Nessun ricaricamento automatico quando esce una versione nuova: la
     * scheda aperta può avere una conversazione in corso, e ricaricarla
     * butterebbe il volontario fuori dalla room (vincolo 5). La versione nuova
     * entra in servizio alla prima apertura successiva.
     */
    registerSW({ immediate: true, onNeedRefresh: () => undefined });
  } catch {
    // Senza service worker la console funziona lo stesso: resta
    // l'interrogazione periodica, che è la rete di sicurezza (O4).
    started = false;
  }
}
